import cloneDeep from 'lodash/cloneDeep';

import preQualifyingQuestionnaire from 'common/questionnaires/definitions/preQual';
import w9Questionnaire from 'common/questionnaires/definitions/w9';
import w8BenQuestionnaire from 'common/questionnaires/definitions/w8Ben';
import w8BeneQuestionnaire from 'common/questionnaires/definitions/w8Bene';
import crsEQuestionnaire from 'common/questionnaires/definitions/crse';
import crsIQuestionnaire from 'common/questionnaires/definitions/crsi';
import crsCpQuestionnaire from 'common/questionnaires/definitions/crscp';
import crsIW8BenQuestionnaire from 'common/questionnaires/definitions/crsiw8ben';
import fatcaCrsEQuestionnaire from 'common/questionnaires/definitions/fatcacrse';
import fatcaCrsIQuestionnaire from 'common/questionnaires/definitions/fatcacrsi';
import w8ImyQuestionnaire from 'common/questionnaires/definitions/w8Imy';
import rc518Questionnaire from 'common/questionnaires/definitions/rc518';
import rc519Questionnaire from 'common/questionnaires/definitions/rc519';

import { prePopulateAnswers } from 'common/questionnaires/prePopulater';

export const createPreQualQuestionnaire = rcEnabled => Object.assign({ answers: {} }, cloneDeep(preQualifyingQuestionnaire(rcEnabled)));

export const createFormQuestionnaire = (formType, accountId, customerData, lockSettings) => {
  let questionnaire = {};
  switch (formType) {
    case 'w9_2018':
    case 'w9_2024':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(w9Questionnaire));
      break;
    case 'w8ben':
    case 'w8ben_2021':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(w8BenQuestionnaire));
      break;
    case 'w8bene_2021':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(w8BeneQuestionnaire));
      break;
    case 'crse':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(crsEQuestionnaire));
      break;
    case 'crsi':
    case 'crsi_2024':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(crsIQuestionnaire));
      break;
    case 'crscp':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(crsCpQuestionnaire));
      break;
    case 'crsiw8ben':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(crsIW8BenQuestionnaire));
      break;
    case 'fatca_crse_2023':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(fatcaCrsEQuestionnaire));
      break;
    case 'fatca_crsi_2023':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(fatcaCrsIQuestionnaire));
      break;
    case 'w8imy_2021':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(w8ImyQuestionnaire));
      break;
    case 'rc518':
    case 'rc518_2024':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(rc518Questionnaire));
      break;
    case 'rc519':
    case 'rc519_2024':
      questionnaire = Object.assign({ answers: {} }, cloneDeep(rc519Questionnaire));
      break;
    default:
      return null;
  }
  prePopulateAnswers(questionnaire, accountId, customerData, lockSettings);
  return questionnaire;
};

export default createFormQuestionnaire;
